var map = {
	"./2d.json": 2188,
	"./3d.json": 2189,
	"./3dplant.json": 2190,
	"./rules.json": 1035
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2187;


//////////////////
// WEBPACK FOOTER
// ./src/data/asset/settings ^\.\/.*\.json$
// module id = 2187
// module chunks = 0